module.exports = __webpack_public_path__ + "static/media/hamburger.417b7a48.svg";